import * as React from "react";
import styled from "styled-components";
import ReactJson from "react-json-view";

import { COLORS } from "@/react/theme/constants";
import { EMPTY_ARRAY } from "@/react/empty";

import {
  JobDetailsContainer,
  JobDetailsSection,
  SectionTitle,
  ScrollableContent,
} from "./styled";
import SummarySection from "./SummarySection";

const ErrorsGrid = styled.div`
  display: grid;
  grid-template-columns: 16px 1fr;
  gap: 8px;
`;

const ErrorIndex = styled.div`
  font-weight: bold;
  text-align: right;
`;

const ErrorMessage = styled.div``;

const NoDataMessage = styled.div``;

const DetailsJsonContainer = styled.div`
  background-color: ${COLORS.background};
  padding: 10px;
  border-radius: 4px;
`;

const UNKNOWN_ERROR = "Unknown Error";

const MainContent = ({ job }) => {
  const { stats, jobData } = job;
  const errors = stats?.errors ?? EMPTY_ARRAY;

  return (
    <JobDetailsContainer>
      <SummarySection job={job} />
      <JobDetailsSection>
        <SectionTitle>Errors</SectionTitle>
        <ScrollableContent>
          <ErrorsGrid>
            {errors.length > 0 ? (
              errors.map((error, index) => (
                <React.Fragment key={index}>
                  <ErrorIndex>{index + 1}.</ErrorIndex>
                  <ErrorMessage>{error ?? UNKNOWN_ERROR}</ErrorMessage>
                </React.Fragment>
              ))
            ) : (
              <NoDataMessage>No errors reported.</NoDataMessage>
            )}
          </ErrorsGrid>
        </ScrollableContent>
      </JobDetailsSection>
      <JobDetailsSection>
        <SectionTitle>Details</SectionTitle>
        <ScrollableContent>
          {jobData ? (
            <DetailsJsonContainer>
              <ReactJson
                src={jobData}
                name={false}
                collapsed={2}
                enableClipboard={true}
                displayDataTypes={false}
                displayObjectSize={false}
              />
            </DetailsJsonContainer>
          ) : (
            <NoDataMessage>No detailed job data available.</NoDataMessage>
          )}
        </ScrollableContent>
      </JobDetailsSection>
    </JobDetailsContainer>
  );
};

export default MainContent;
